import { Link } from "react-router-dom";

interface AuthAltLinkProps {
  text: string;
  linkText: string;
  to: string;
}

export function AuthAltLink({ text, linkText, to }: AuthAltLinkProps) {
  return (
    <div className="gfg-auth-alt">
      {text} <Link to={to}>{linkText}</Link>
    </div>
  );
}
